import React from 'react';
import { NavSearch } from './nav-search';
import styled from 'styled-components';
import { FlexColumn, FlexRow, useMatchMedia } from '@make-software/cspr-ui';
import { NavMetrics } from './nav-metrics';
import { TextAdsBanner } from '../../components/ads-banner/text-ads-banner';
import { HomeAdsBanner } from '../../components/ads-banner/ads-banners-by-page';

const SearchWithBannerContainer = styled(FlexRow)(({ theme }) =>
  theme.withMedia({
    maxWidth: theme.maxWidth,
    width: ['100%', '100%', '89%', '100%'],
    padding: ['16px 16px 24px', '16px 32px 0px', '24px 0 40px', '24px 0 40px'],
    margin: 0,
    justifyContent: 'space-between',
    alignItems: ['center', 'center', 'end', 'end'],
  })
);

const MetricsContainer = styled.div(({ theme }) =>
  theme.withMedia({
    display: 'flex',
    flexDirection: ['row'],
    alignItems: 'center',
    width: '100%',
    padding: ['16px', '16px 32px', '16px 56px 16px', '16px 0'],
    margin: 0,
  })
);

const DetailsSearchbarContainer = styled(FlexColumn)(({ theme }) =>
  theme.withMedia({
    width: '100%',
    maxWidth: theme.maxWidth,
    padding: '16px 0',
    justifyContent: 'space-between',
  })
);

const HomeTextAdContainer = styled(FlexColumn)(({ theme }) =>
  theme.withMedia({
    width: ['100%', '100%', '60%'],
  })
);

const DetailsTextAdContainer = styled(FlexRow)(({ theme }) =>
  theme.withMedia({
    maxWidth: theme.maxWidth,
    padding: ['0 16px', '0 32px', '0 56px', '0'],
  })
);

interface SearchWithAdBannerProps {
  isHome?: boolean;
}

const SearchWithAdBanner = ({ isHome = false }: SearchWithAdBannerProps) => {
  const screenType = useMatchMedia(['mobile', 'tablet', 'desktop'], []);
  const isDesktop = screenType === 'desktop';

  if (isHome) {
    return (
      <SearchWithBannerContainer>
        <HomeTextAdContainer itemsSpacing={20}>
          <NavSearch />
          <TextAdsBanner />
        </HomeTextAdContainer>
        {isDesktop && <HomeAdsBanner screenType={screenType} />}
      </SearchWithBannerContainer>
    );
  }
  return (
    <DetailsSearchbarContainer>
      <MetricsContainer>
        {isDesktop && <NavMetrics />}
        <NavSearch />
      </MetricsContainer>
      <DetailsTextAdContainer>
        <TextAdsBanner />
      </DetailsTextAdContainer>
    </DetailsSearchbarContainer>
  );
};

export default SearchWithAdBanner;
